module.exports = __webpack_public_path__ + "6b4a555be728dc9fded76bd1dce5311c.png";